import { makeStyles, Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import classnames from 'classnames';
import * as React from 'react';
const useStyles = makeStyles({
    DiscrepancyIndicator: {
        color: '#3fb1d3',
        display: 'flex',
        placeItems: 'center',
    }
});
export const DiscrepancyIndicator = (props) => {
    const { title, className } = props;
    const styles = useStyles();
    return (React.createElement("div", { className: classnames(styles.DiscrepancyIndicator, className) },
        React.createElement(Tooltip, { arrow: true, placement: 'top', title: title },
            React.createElement(InfoIcon, null))));
};
export default DiscrepancyIndicator;
